module.exports = __webpack_public_path__ + "static/sav.banner-mosaic-base-reta-1d99d556472609aaa8830fd63c442f6e.jpg";